




import {Component, Vue} from 'vue-property-decorator';
import {loginService} from '@/services/login.service';
import {BizSirenResultDto} from '@/services/LoginModels';

@Component
export default class BizSirenCallBackPhone extends Vue {
  private cryptoTokenId: string = this.$route.query.crypto_token_id as string;
  private integrityValue: string = this.$route.query.integrity_value as string;
  private type = 'phone';

  mounted(): void {
    console.log(this.cryptoTokenId);
    if (this.cryptoTokenId) {
      loginService.getBizSirenPhoneDecodeV4(this.type, this.cryptoTokenId, this.integrityValue).then(response => {
        if (response.status == 200) {
          const responseDataRet = response.data as BizSirenResultDto;
          console.log(responseDataRet);
          window.opener.recvSirenPhoneResult(this.type, responseDataRet, '');
          window.close();
        } else {
          //http response 오류 처리
          this.$bvModal
            .msgBoxOk('인증정보를 처리시 알수없는 오류가 발생했습니다', {
              title: '오류발생',
              okVariant: 'danger',
              centered: true,
            })
            .then(value => {
              window.close();
            });
        }
      });
    }
  }
}
